/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { createSkillRequestSchema } from './createSkillRequestSchema';

export const createBulkSkillsRequestSchema = z.object({
  get skills() {
    return z.array(createSkillRequestSchema).min(1);
  },
});
